import React, {useContext} from 'react'
import update from 'immutability-helper'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import InfoBar from './components/homework-students/info-bar'
import HomeworkStudentsHead from './components/homework-students/homework-students-head'
import HomeworkStudentsBody from './components/homework-students/homework-students-body'
import {createPost} from 'helpers/command'

import {TeacherContext} from 'teacher/context'

const useStyles = makeStyles(homeworkStyles)

export default function HomeworkStudents() {

  const context = useContext(TeacherContext)
  const {homeworkStatusMap, homeworkId} = context
  const classes = useStyles()  
  const [state, setState] = React.useState({feedback: []})

  function selectStudentForFeedback(id, selected, initial) {    
    
    let cmd = {$push: [{id, message: '', score: "", returned: false, ...initial}]}
    if(!selected) {
      const index = state.feedback.findIndex(i=> i.id == id)
      cmd = {$splice: [[index, 1]]}
    }
        
    setState(update(state, {feedback: cmd }))
  }
  
  function updateFeedback(id, property, value) {
    const index = state.feedback.findIndex(i=> i.id == id)
    const cmd = {[index]: {[property]: {$set: value}}}
    setState(update(state, {feedback: cmd }))
  }
  
  const save = async ()=> {
    
    const students = state.feedback.map(f => {      
      return {
        id: f.id,
        status: homeworkStatusMap[f.returned?'returned':'completed'],
        score: f.score===''?undefined:parseInt(f.score),
        message: f.message
      }
    })
    const result = await createPost('homework', 'saveStudentsFeedback')({id: homeworkId, students})
    setState(update(state, {feedback: {$set: []}}))
    context.updateState({homeworkContext: {studentHomeworkStatus: {refreshes: {$apply: r => r + 1}}}})
  }

  return (
    <Box className={classes.root} >
      <InfoBar {...{context, save, showSave: state.feedback.length > 0}} />  
      <Box className={classes.content}>
        <TableContainer className={classes.container}>
          <Table className={classes.table}>
            <HomeworkStudentsHead context={context} />
            <HomeworkStudentsBody {...{context, feedback: state.feedback, selectStudentForFeedback, updateFeedback}} />
          </Table>
        </TableContainer>
      </Box>
    </Box>
  )
}

function homeworkStyles() {
 return {
    root: {
      flexGrow: 1,
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      borderRadius: '4px',
      boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)'
    },
    content: {
      display: 'flex',
      flexGrow: 1,
      overflow: 'hidden',
    },
    container: {
      flexGrow: 1,
      overflow: 'auto',
    },
    chips: {
      padding: 10,
      '& .filter-chip': {
        backgroundColor: '#de3434',
        color: '#fff',
        '& .MuiChip-label': {
          padding: '0 20px'
        },
        '& .MuiChip-deleteIcon': {
        }
      }
    },
    filters: {
      display: 'flex',
      padding: '0 15px 8px 15px',
      "& .create-quiz-wrapper": {
        display: "flex",
        marginTop: 15,
        flexDirection: "column",
        justifyContent: "center",
        paddingLeft: 15
      }
    },
    createButton: {
      margin: '10px'
    }
  }
}
